<template>
    <div class="bg productCenter">
        <div class="up-wrap" v-if="isShowUp">
            <div class="w-1200 flex-between">
            <div class="blk" @click="scrollTo(1)">
                <img src="../assets/images/productCenter/up_01.png" alt="">
                <p>数字声像系统</p>
            </div>
            <div class="blk" @click="scrollTo(2)">
                <img src="../assets/images/productCenter/up_02.png" alt="">
                <p>文档大数据平台</p>
            </div>
            <div class="blk" @click="scrollTo(3)">
                <img src="../assets/images/productCenter/up_03.png" alt="">
                <p>智慧党建系统</p>
            </div>
            <div class="blk" @click="scrollTo(4)">
                <img src="../assets/images/productCenter/up_04.png" alt="">
                <p>智慧执法系统</p>
            </div>
            </div>
        </div>
        <headerCom></headerCom> 
        <div class="w-body title-wrap" style="margin:60px auto 32px">
            <div class="name">产品中心</div>
            <div class="interval-line"></div>
            <div class="e-name">PRODUCT CENTER</div>
        </div>
        <div class="w-body flex-between">
            <div class="item-c">
                <img src="../assets/images/productCenter/item_01.png" alt="">
                <p class="title">数字声像系统</p>
                <p style="text-align:left;">实现企业级的数字资产管理，对图片、音频、视频、数字化文档等类资源进行统一管理和智能存储能。</p>
            </div>
            <div class="item-c">
                <img src="../assets/images/productCenter/item_02.png" alt="">
                <p class="title">智慧执法系统</p>
                <p style="text-align:left;">实践“智慧+执法”模式，“最多跑一次”理念为引领，整合城市管理部门数据，强化数据分析，打造行政执法智慧大平台。</p>
            </div>
            <div class="item-c">
                <img src="../assets/images/productCenter/item_03.png" alt="">
                <p class="title">文档大数据平台</p>
                <p style="text-align:left;">联通互联网、政务网、馆藏内网三网，实现集汇交、收集、管理、利用、服务全过程  的数字化、网络化、精细化、智慧化管控。</p>
            </div>
            <div class="item-c">
                <img src="../assets/images/productCenter/item_04.png" alt="">
                <p class="title">智慧党建系统</p>
                <p style="text-align:left;"> 通过智慧党建平台,及时传达党讯的消息,广大群众和党员通过手机端和PC端第一时间了解党情、民情,提高效率。</p>
            </div>
        </div>
        <!-- 1 -->
        <div class="blk1" ref="p1">
            <div class="bg-1">
                <div class="title">
                    数字声像系统
                </div>
                <div class="w-body flex-between">
                    <div class="mess">
                        <p class="name">
                            载体类别采集渠道
                        </p>
                        <p class="l"></p>
                        <p>为适应新时代发展，更高满足各企事业单位的发展历程、企业荣誉、互动事务、应急报道，我们提出与新媒体相融合的新思路,拟采用新技术、新框架对声像数据多方位实时采集、多层级审核、全过程监控、多内容管理、多方式浏览、以及大数据分析和应急指挥一体化管理，搭建实现真正意义上的规范化、网络化、数字化、流程化声像资源管理系统，更好地提高声像多媒体档案的数据管理和利用水平。</p>
                    </div>
                    <img src="../assets/images/productCenter/blk_01.png" alt="">
                </div>
            </div>
            <div class="bg-2">
                <div class="title"> 
                    四大功能亮点
                </div>
                <div class="four w-body">
                    <div class="k">
                        <div class="flex-start flex-m">
                            <img src="../assets/images/productCenter/k_01.png" alt="">
                            <p>人性化服务轻松搞定</p>
                        </div>
                        <div class="bottom">
                            系统支持无人机、摄相机、数码相机、手机、执法仪等拍摄成果,按标准导入系统审核。视频文件格式支特AVI.WMV等;音频类包括MP3、MAV等;图像文件包括支持JPG、TIF、BMP、PNG等;文档支持DOC、PDF等格式。
                        </div>
                    </div>
                    <div class="k">
                        <div class="flex-start flex-m">
                            <img src="../assets/images/productCenter/k_02.png" alt="">
                            <p>分层管理逻辑更清晰</p>
                        </div>
                        <div class="bottom">
                            系统提供个人、部门级、公司级三级管理,建立个人和部门素材库，公司级档案库，分级维护和共享。提供功能、对象、密级、群组授权。针对管理资源对象提供多权限用户定义。提供档案分类树、部门结构树、时间树。结构灵活管理快速查阅，轻松获取。
                        </div>
                    </div>
                    <div class="k">
                        <div class="flex-start flex-m">
                            <img src="../assets/images/productCenter/k_03.png" alt="">
                            <p>运用时间轴数据更直观</p>
                        </div>
                        <div class="bottom">
                            “时间轴”动态展现按照企事业单位“时间元素”主线建立关联,运用大数据手段展示如国家领导人考察、工程里程碑等,对资源合集愉悦浏览。系统设立企事业单位年度大事记、领导关怀等专题模板，建立照片专题库，同样以“时间轴”方式图文并茂展现,享受美感。
                        </div>
                    </div>
                    <div class="k">
                        <div class="flex-start flex-m">
                            <img src="../assets/images/productCenter/k_04.png" alt="">
                            <p>人脸识别流程自定义</p>
                        </div>
                        <div class="bottom">
                            提供照片档案库每一组、每一张照片人脸识别建库。实现人脸比对。快速找寻所需要的重要人员档案。系统提供各种资源访问操作权限申请流程。各类对象借阅管理流程、声像档案销毁流程等自定义。
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 2 -->
        <div class="blk2" ref="p2">
            <div class="bg-1">
                <div class="title">
                    文档大数据平台
                </div>
                <div class="w-body flex-between">
                    <div class="mess">
                        <p class="name">
                            智慧文档一张图
                        </p>
                        <p class="l"></p>
                        <p>智慧文档建设是一项系统工程。集政府政策、法规标准、档案理论、信息技术、数据安全、人员素质、资料来源于―体总体规划、分步实施，优业务重数据、讲事实重服务，以“大文档、大数据、大文化、大开放、现代化、流程化、数字化、规范化为理念，智造网络、人员、数据、机器人无缝结合的智慧档案“一张图”。</p>
                    </div>
                    <img src="../assets/images/productCenter/blk_02.png" alt="">
                </div>
            </div>
            <div class="bg-2">
                <div class="title"> 
                    系统特色
                </div>
                <div class="flex-start w-body">
                    <img src="../assets/images/productCenter/bg2_2.png" alt="">
                    <div>
                        <p>伴随着“智慧地球”理念提出，“智慧城市”进入人们的视野。“智慧档案馆”是“智慧城市”"的重要组成部分,是新时代社会发展的客观要求。其特色包括:</p>
                        <p>从技术角度看:云计算、大数据、物联网、人工智能等新信息技术改变用户和档案馆之间的数据资源交互方法,提高了服务的灵活性、准确性、便捷性;</p>
                        <p>从管理角度看:智能、科学管理多元化的档案资源。具备感知和处置能力。提高了档案数据的完整性、正确性、安全性;</p>
                        <p>从实践角度看:应用信息技术和实体建筑设施优化融合,做到自动监控、智动整合,提高了档案一体化、网络化、个性化服务水平。</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 3 -->
        <div class="blk3" ref="p4">
            <div class="bg-1">
                <div class="title">
                    智慧执法系统
                </div>
                <div class="w-body flex-between">
                    <div class="mess">
                        <p class="name">
                            城市管理大数据中心
                        </p>
                        <p class="l"></p>
                        <p>随着我国城市化的进程加快和社会经济的迅猛发展，人们对于生活水平质量的要求日益提高,城市管理成为城市发展的永恒主题,城市管理综合行政执法则是城市管理的重要手段之一。</p>
                        <p>按照国务院、省委省政府要求的积极推进城市综合管理,提高执法水平。在大数据时代的我们，需要建章立制规范队伍、强化培训提升能力、健全考核追究责任、运用技术搭建系统。让“数据多跑路、人员少跑腿”。有效采用科技手段提升执法人员的权威性、积极性、安全性。保证文明执法、清廉执法、高效执法。</p>
                    </div>
                    <img src="../assets/images/productCenter/blk_03.png" alt="">
                </div>
            </div>
            <div class="bg-2">
                <div class="title"> 
                    系统特色
                </div>
                <div class="flex-start w-body">
                    <img src="../assets/images/productCenter/bg2_3.png" alt="">
                    <div>
                        <p>执法管理系统所拥有的人工智能A技术、视频传输技术、大数据分析技术和安全认证技术等实践,为应急管理执法、文化旅游执法、农业综合执法、生态环保执法和市场监管执法等提供理念借鉴,进一步为深化实施"智慧+互联网"执法提供技术支撑。</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 4 -->
        <div class="blk4" ref="p3">
            <div class="bg-1">
                <div class="title">
                    智慧党建系统
                </div>
                <div class="w-body flex-between">
                    <div class="mess">
                        <p class="name">
                            智慧化基层建设
                        </p>
                        <p class="l"></p>
                        <p>智慧党建是一项系统工程。集政府政策、法规标准、档案理论、信息技术、数据安全、人员素质、资料来源于―体总体规划其大数据分析让党群服务中心管理人员及从繁琐、低效的数据采集和数据分析工作中解放出来，取而代之的是更轻便、高效的系统自动化分析展示，提升了整体的工作效率。</p>
                    </div>
                    <img src="../assets/images/productCenter/blk_04.png" alt="">
                </div>
            </div>
            <div class="bg-2">
                <div class="title"> 
                    系统特色
                </div>
                <div class="flex-start w-body">
                    <img src="../assets/images/productCenter/bg2_4.png" alt="">
                    <div>
                        <p>包括活动名称、活动封面、相关标签、活动时间、活动状态等，支持活动创建、活动查询、报名记录查看，链接复制等功能。</p>
                        <p>社区议事</p>
                        <p>主要包括议事标题、议事时间、发起人、发布时间、协调单位、议事状态，支持议事的创建、联系方式、议事类型、活动地址等信息。</p>
                        <p>包括共性类指标、排名类指标、分档类指标、创优类指标、负面类指标等方面内容。</p>
                        <p>各个乡镇/村的村党组织书记评定信息的相关新增、修改、删除等操作。</p>
                        <p>各单位根据不同接收单位联查情况，对核查结果进行批量导入关联。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import headerCom from "../components/header";
import {
    list,
} from "../api/product.js";
export default {
    name: "page",
    components: {
        headerCom
    },
    data() {
        return {
            httpUrl: process.env.VUE_APP_URL,
            isShowUp:false,
            fullHeight:"",
            offTop:"",

            productList:[],
        };
    },
     mounted() {
        document.addEventListener("scroll", this.handleScroll);
    },
    methods: {
        //-------
        listFun() {
            list().then((res) => {
                if (res.code == 200) {
                    this.productList=res.data;
                }
            });
        },
        // --------
        scrollTo(val){
            if(val==1){
               this.offTop=this.$refs.p1.offsetTop-164
            }
            if(val==2){
               this.offTop=this.$refs.p2.offsetTop-164
            }
            if(val==3){
               this.offTop=this.$refs.p3.offsetTop-164
            }
            if(val==4){
               this.offTop=this.$refs.p4.offsetTop-164
            }
            if(val==5){
               this.offTop=this.$refs.p5.offsetTop-164
            }
            if(val==6){
               this.offTop=this.$refs.p6.offsetTop-164
            }
            window.scrollTo(0, this.offTop);
        },
        handleScroll: function () {
            clearTimeout(this.timer2);
            let _this = this;
            this.timer2 = setTimeout(() => {
                let scrollTop = document.documentElement.scrollTop;
                if (scrollTop > this.fullHeight) {
                    this.isShowUp = true;
                } else {
                    this.isShowUp = false;
                }
            }, 100);
        },
    },
    created(){
        window.fullHeight = document.documentElement.clientHeight;
        this.fullHeight= window.fullHeight;
        this.listFun();
    }
}
</script>
<style lang="less" scoped>
@import "../assets/css/base.less";
</style>


